import React from "react";
import { Modal, Segment, Button } from "semantic-ui-react";
const PlanModal = props => {
  const { open, closeModal } = props;

  return (
    <Modal
      open={open}
      onClose={closeModal}
      basic
      closeOnDimmerClick={false}
      className='modal__plan'
    >
      <Modal.Content scrolling className="ui centered grid mx-0">
        <Segment inverted className="not-yet-avail w-400">
          <p className="avail__desc">
            100 Mbps is our most popular package. If you're a power user, consider our faster speeds.
                  </p>
          <div>
            <Button secondary className="text-prime medium" onClick={closeModal}>Close</Button>
          </div>
        </Segment>
      </Modal.Content>
    </Modal>
  )
};

export default PlanModal;


// WEBPACK FOOTER //
// ./src/components/home/choose-speed/PlanModal.js